export const truncatetext = (text, length) => {
  let newtext = '';
  if (text && text.length > 0) {
    newtext = text.length > length ? `${text.slice(0, length)}...` : text;
  }
  return newtext;
};
